export default __webpack_public_path__ + "static/media/581.55d54965.png";